import { MALL_ICONS } from '@mg/micro/vue2'
import {
  FLASH_MESSAGE_SHOW_TOAST,
  FlashMessage,
} from '@mg/web-components/Atoms/FlashMessageBox/types'
import { TranslateResult } from 'vue-i18n'

export default class Toaster {
  showError(text: TranslateResult, title: TranslateResult = '') {
    const message = this.createErrorMessage(text, title)
    window?.$nuxt?.$root.$emit(FLASH_MESSAGE_SHOW_TOAST, message)
  }

  showSuccess(text: TranslateResult, title: TranslateResult = '') {
    const message = this.createSuccessMessage(text, title)
    window?.$nuxt?.$root.$emit(FLASH_MESSAGE_SHOW_TOAST, message)
  }

  showInfo(text: TranslateResult, title: TranslateResult = '') {
    const message = this.createInfoMessage(text, title)
    window?.$nuxt?.$root.$emit(FLASH_MESSAGE_SHOW_TOAST, message)
  }

  showMessage(message: FlashMessage) {
    window?.$nuxt?.$root.$emit(FLASH_MESSAGE_SHOW_TOAST, message)
  }

  createErrorMessage(
    text: TranslateResult,
    title: TranslateResult = '',
    timeout?: number,
    icon?: MALL_ICONS,
    iconColor?: string
  ): FlashMessage {
    return {
      type: 'danger',
      icon: icon || MALL_ICONS.ALERT,
      iconOffsetTop: title ? 7 : 0,
      text: text as string,
      title: title && (title as string),
      timeout,
      isToast: true,
      iconColor,
    }
  }

  createSuccessMessage(
    text: TranslateResult,
    title: TranslateResult = '',
    timeout?: number,
    icon?: MALL_ICONS,
    iconColor?: string
  ): FlashMessage {
    return {
      type: 'success',
      icon: icon || MALL_ICONS.CHECK,
      iconOffsetTop: title ? 5 : 0,
      text: text as string,
      title: title && (title as string),
      timeout,
      isToast: true,
      iconColor,
    }
  }

  createInfoMessage(
    text: TranslateResult,
    title: TranslateResult = '',
    timeout?: number,
    icon?: MALL_ICONS,
    iconColor?: string
  ): FlashMessage {
    return {
      type: 'info',
      icon: icon || MALL_ICONS.INFO_IN_EMPTY_CIRCLE,
      iconOffsetTop: title ? 7 : 0,
      text: text as string,
      title: title && (title as string),
      timeout,
      isToast: true,
      iconColor,
    }
  }
}
